import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode, useMemo } from 'react';

import { useSnackbars } from '../hooks/useSnackbars';

type ReactQueryProviderProps = {
  children: ReactNode;
};

export const ReactQueryProvider = ({ children }: ReactQueryProviderProps) => {
  const { showErrorSnackbar } = useSnackbars();

  const queryClient = useMemo(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          refetchOnWindowFocus: false,
        },
        mutations: {
          // Mutations také neretryujeme pro HTTP chyby
          retry: (failureCount, error) => {
            if (error && typeof error === 'object' && 'status' in error) {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              const status = (error as any).status;
              if (status >= 400 && status < 600) {
                return false;
              }
            }
            return failureCount < 2;
          },
        },
      },
      queryCache: new QueryCache({
        onError: (error) => {
          showErrorSnackbar(`Something went wrong: ${error instanceof Error ? error.message : String(error)}`);
        },
      }),
    });
  }, [showErrorSnackbar]);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
